import { user_profileActions } from "actions";
import {
    GENERIC_ERROR,
    POLL_BACKOFF_AFTER_MS,
    POLL_BUDGET_MS,
    POLL_FAST_INTERVAL_MS,
    POLL_SLOW_INTERVAL_MS,
    TIMEOUT_MESSAGE
} from "./constants";

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export const pollIntervalAt = elapsed_ms =>
    (elapsed_ms < POLL_BACKOFF_AFTER_MS ? POLL_FAST_INTERVAL_MS : POLL_SLOW_INTERVAL_MS);

// Subclassing Error survives neither transpiling nor `instanceof` reliably, and
// the caller only needs to tell "not finished yet" from "broken".
export const stillBuildingError = () =>
    Object.assign(new Error(TIMEOUT_MESSAGE), { stillBuilding: true });

// Resolves the finished export once it is built, null if the caller stopped
// caring. Throws when the job fails or outlives our patience.
export async function waitForExport(userId, token, { isAbandoned, onStillWaiting }) {
    let elapsed_ms = 0;
    let warned_of_wait = false;

    while (elapsed_ms < POLL_BUDGET_MS) {
        const interval_ms = pollIntervalAt(elapsed_ms);

        await sleep(interval_ms);
        elapsed_ms += interval_ms;

        if (isAbandoned()) return null;

        const statistics_export = await user_profileActions.getStatisticsExport(userId, token);
        const { export_status, error } = statistics_export;

        if (export_status === "completed") return statistics_export;
        if (export_status === "failed") throw new Error(error || GENERIC_ERROR);

        // Only once we know the export missed the fast window, so a quick one
        // never flashes it.
        if (!warned_of_wait && elapsed_ms >= POLL_BACKOFF_AFTER_MS && !isAbandoned()) {
            warned_of_wait = true;
            onStillWaiting();
        }
    }

    throw stillBuildingError();
}
